import React from "react"

const Codepen = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width="22.785"
    height="22"
    viewBox="0 0 22.785 22"
  >
    <g
      id="Codepen-group"
      data-name="Codepen-group"
      transform="translate(-0.607 -1)"
    >
      <path
        id="Path_7183"
        data-name="Path 7183"
        d="M12,2,22,8.5v7L12,22,2,15.5v-7Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <line
        id="Line_10"
        data-name="Line 10"
        y1="6.5"
        transform="translate(12 15.5)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        id="Path_7184"
        data-name="Path 7184"
        d="M22,8.5l-10,7L2,8.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        id="Path_7185"
        data-name="Path 7185"
        d="M2,15.5l10-7,10,7"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <line
        id="Line_11"
        data-name="Line 11"
        y2="6.5"
        transform="translate(12 2)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>
)

export default Codepen
